'use client';

import { ProtectedRoute } from '@/modules/auth/components/ProtectedRoute';

export function ProtectedPage({ children }: { children: React.ReactNode }) {
  return <ProtectedRoute>{children}</ProtectedRoute>;
}
